// client/src/coms/serveradmin/ReportHost.js
// One report dialog for the whole app: window.dispatchEvent(new CustomEvent('vox-report', { detail: target }))
// with target { type: 'user' | 'file' | 'server' | 'activity', serverKey, userId, uploadId, fileId, ref, label }.
import React, { useEffect, useState } from 'react';
import ReportDialog from '../components/ReportDialog';

export default function ReportHost() {
  const [target, setTarget] = useState(null);
  useEffect(() => {
    const on = (e) => {
      const t = e && e.detail;
      if (t && t.type && t.serverKey) setTarget(t);
    };
    window.addEventListener('vox-report', on);
    return () => window.removeEventListener('vox-report', on);
  }, []);
  if (!target) return null;
  return <ReportDialog target={target} onClose={() => setTarget(null)} />;
}
